@if (headline() || subheadlineValue() || subheadline()) {
  <div class="shopping-flow-bar__details" [class.shopping-flow-bar__details--summary]="subheadlineValue()">
    @if (headline()) {
      <div class="shopping-flow-bar__title">{{ headline() | ltTranslate: headlineParams() }}</div>
    }
    @if (subheadlineValue()) {
      <div class="shopping-flow-bar__summary">
        <span class="shopping-flow-bar__summary-label">{{ subheadline() | ltTranslate: subheadlineParams() }}</span>
        <span class="shopping-flow-bar__summary-value">{{ subheadlineValue() }}</span>
      </div>
    } @else if (subheadline()) {
      <div class="shopping-flow-bar__text">
        <span class="should-stay-masked">{{ subheadline() | ltTranslate: subheadlineParams() }}</span>
      </div>
    }
  </div>
}

<button
  class="btn lt-btn shopping-flow-bar__action-btn"
  [class.shopping-flow-bar__action-btn--summary]="subheadlineValue()"
  [class.shopping-flow-bar__action-btn--disabled]="isDisabled()"
  [class.shopping-flow-bar__action-btn--inactive]="isInactive()"
  data-testid="shopping-flow-bar-continue-btn"
  [disabled]="isDisabled()"
  (click)="onContinueClick()"
>
  @if (ctaIcon() === 'lock') {
    <lt-icon
      name="fa-regular-lock"
      class="shopping-flow-bar__action-icon shopping-flow-bar__action-icon--leading"
    ></lt-icon>
  }
  <span>{{ ctaLabel() | ltTranslate: ctaLabelParams() }}</span>
  @if (ctaIcon() === 'arrow') {
    <lt-icon name="fa-sharp-solid-arrow-right" class="shopping-flow-bar__action-icon"></lt-icon>
  }
</button>
